import { Button } from '@chakra-ui/react';
import { useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import GoogleIcon from '@/icons/Google';
import { useAuth } from '@/hooks';

export const GoogleLogin = () => {
  const [csrfToken, setCsrfToken] = useState('');
  const { fetchLogin } = useAuth();

  const onSubmitGoogleLogin = async (event) => {
    const form = event.target;

    // proceed with normal submit if CSRF token is already there
    if (form.elements['authenticity_token']?.value) return;

    // otherwise, fetch the CSRF token, attach it to the form, then submit
    event.preventDefault();
    const newToken = (await fetchLogin())?.data?.csrf_token;
    if (newToken) {
      setCsrfToken(newToken);
      setTimeout(() => form.submit(), 500);
    }
  };

  const { tFeGoogleIncrementalScopes } = useFlags();

  const googleOauthParams = new URLSearchParams({
    for: 'signin',
    origin: window.location.href,
  });

  if (!tFeGoogleIncrementalScopes) {
    googleOauthParams.delete('for'); // revert to old behaviour
  }

  return (
    <form
      method="post"
      action={`/api/v1/auth/google_oauth2?${googleOauthParams}`}
      onSubmit={onSubmitGoogleLogin}
    >
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      <Button
        type="submit"
        variant="quaternary"
        height="40px"
        leftIcon={<GoogleIcon />}
        width="full"
      >
        Sign in with Google
      </Button>
    </form>
  );
};
